<template>
<div class="center">
    <div class="center fs18" style="padding-top: 40px;">
        <p class="black fs32 fw500">{{ $t('s1') }}</p>
        <span class="backyel dib divide"></span>
        <p class="gray fw500">{{ $t('s11') }}</p>
    </div>
    <img :src="servicesurl" alt="" :class="$style.img" class="showInSmall">
    <img :src="servicesweburl" alt="" :class="$style.imgweb" class="showInLarge">
</div>
</template>
<script>
// import servicesen from '../assets/serviceen.png';
// import serviceszh from '../assets/servicecn.jpeg';
import servicesen from '../assets/serviceenNew.png';
import serviceszh from '../assets/serviceenNew.png';
import servicesweben from '../assets/processing_en-01.jpg';
import serviceswebzh from '../assets/processing_cn-01.jpg';

export default {
    name: 'Services',
    data() {
        return {
            servicesurl: this.$i18n.locale === 'en' ? servicesen : serviceszh,
            servicesweburl: this.$i18n.locale === 'en' ? servicesweben : serviceswebzh,
        };
    },
    created() {
        this.$top();
    }
}
</script>
<style module>
.img {
    width: 40%;
}
.imgweb {
    width: 75%;
    margin-top:50px;
}
@media screen and (max-width: 770px) {
    .img {
        width: 90%;
    }
}
</style>
